import React, { useState, useEffect } from 'react';
import CTRLF5 from '../../assets/img/CTRLF5.gif';
import logoOpera from '../../assets/img/LOGO_OPERA.png';
import { dominioDemandaCirurgica } from '../../config/database';
import packageJson from '../../../package.json';
import { Redirect } from 'react-router-dom';

export default function AvisoAtualizacaoOpera() {
  const [redireciona, setRedireciona] = useState(false);

  useEffect(() => {
    dominioDemandaCirurgica.get('/api/versaoOpera').then(res => {
      setRedireciona(res.data.versao === packageJson.version);
    });
  }, []);

  if (redireciona) return <Redirect from="/" to="/admin" />;

  return (
    <div style={{ textAlign: 'center' }}>
      <img alt="logo" style={{ width: '10%', height: '10%' }} src={logoOpera} />
      <p>Você está utilizando uma versão desatualizada do Opera!</p>
      <p>Atualize seu navegador para conferir os últimos recursos e ter a melhor experiência.</p>
      <p>
        Utilize o comando CTRL + F5 para atualizar ou entre em contato com o DTI através do ramal
        1775.
      </p>
      <img alt="ctrlf5" style={{ width: '75%', height: '75%' }} src={CTRLF5} />
    </div>
  );
}
